import { Component, OnInit, Inject } from '@angular/core';
import { AlertComponent } from 'ngx-bootstrap/alert/alert.component';
import { PositionFacade } from '../../../common/facade/PositionFacade';
import { Position } from '../../../common/model/Position';
import { Router } from '@angular/router';
import {SESSION_STORAGE, WebStorageService} from 'ngx-webstorage-service';
import { Permissions } from '../../../common/model/dictionary/Permissions';
import { Strings } from '../../../common/language/strings';
import { res } from '../../../common/language/text/res';

@Component({
  selector: 'app-organization-chart',
  templateUrl: './organization-chart.component.html',
  styleUrls: ['./organization-chart.component.css']
})
export class OrganizationChartComponent implements OnInit {
  titleStoreManagementByUser = res.StoreManagementByUser;
  lblAdd = res.Add;
  lblSearch = res.Search;
  lblPosition = res.Position;
  lblName = res.Name;
  lblAssignedStores = res.AssignedStores;
  lblAllMayusA = res.AllMayusA;
  lblDelete = res.Delete;

  isSpanish = true;
  language = 0

  messagesTable : any = {
    emptyMessage: "",
    totalMessage: "" 
  }

  loading = false;
  messageLoader = '';
  generalAlerts = [];

  // permissions
  permissionsList: any[] = [];

  // buttons
  visibleAdd = false;
  visibleEdit = false;

  // table
  rows: Position[];
  private _filteredData: Position[];

  constructor (
    @Inject(SESSION_STORAGE) private _storage: WebStorageService,
    private router: Router,
    private positionService: PositionFacade,
    public strings: Strings,
    private _router: Router
  ) {
    this._storage.set('moduleUrl', this._router.url);
   }

  ngOnInit() {
    this.loading = true
    
    this.isSpanish = this.strings.getLanguageIsSpanish();

    this.messagesTable.emptyMessage = this.strings.GetText(res.ThereIsNoInformation);
    this.messagesTable.totalMessage = 'Total';

    if (!this.isSpanish) {
      this.language = 1
    }

    this.validatePermissions();
    this.obtenerPositions();
  }

  validatePermissions() {
    this.permissionsList = this._storage.get('permissions');
    
    // validar si cuenta con el permiso para añadir un nuevo puesto
    this.permissionsList.forEach(element => {
        if (element.name == Permissions.GeneralAccess || element.name == Permissions.ConfigPositionCreate){
          this.visibleAdd = true;
        }
      });

    // validar si cuenta con el permiso para editar o borrar un puesto
    this.permissionsList.forEach(element => {
        if (element.name == Permissions.GeneralAccess || element.name == Permissions.ConfigPositionEdit){
          this.visibleEdit = true;
        }
      });
  }

  obtenerPositions() {
    this.loading = true;
    this.messageLoader = this.strings.GetText(res.Loading);
    this.positionService.GetPosition().subscribe(
      response => {
        this.loading = false;
        if (response.completed) {
          this._filteredData = response.data;
          this.rows = response.data;
        } else {
          this.addGeneralAlert('<strong>' + this.strings.GetText(res.TheOrganizationChartCouldNotBeDisplayed) + ', ' + response.message + '</strong>');
        }
      }, error => {
        this.loading = false;
        this.addGeneralAlert('<strong>' + error + '<strong>');
        return;
      }
    );
  }

  gotoDetail(id) {
    this.router.navigate(['/config/organization-chart/', id]);
  }

  deletePosition(id) {
    this.loading = true;
    this.messageLoader = this.strings.GetText(res.DeletingUser);
    this.positionService.DeletePosition(id).subscribe(
      response => {
        this.loading = false;
        if (response.completed) {
          this.obtenerPositions();
        } else {
          this.addGeneralAlert('<strong>' + this.strings.GetText(res.CouldNotDeleteThisUser) + ', ' + response.message + '</strong>');
        }
      }, error => {
        this.loading = false;
        this.addGeneralAlert('<strong>' + error + '<strong>');
      }
    );
  }

  // añadir alert
  addGeneralAlert(message: String): void {
    this.generalAlerts = [];
    this.generalAlerts.push({
      type: 'danger',
      msg: message
    });
  }

  onClosed(dismissedAlert: AlertComponent): void {
    this.generalAlerts = this.generalAlerts.filter(alert => alert !== dismissedAlert);
  }

  updateFilter(event) {
    // get the value of the key pressed and make it lowercase
    const val = event.target.value.toLowerCase();
    // get the key names of each column in the dataset
    const keys = Object.keys(this._filteredData[0]);
    // assign filtered matches to the active datatable
    this.rows = this._filteredData.filter(function (item) {
        // iterate through each row's column data
        for (let i = 0; i < keys.length; i++) {
            if (item[keys[i]] != null && (item[keys[i]].toString().toLowerCase().indexOf(val) !== -1 || !val)) {
                return true;
            }
        }
    });
  }

}
